import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const AddDayStartClose = () => {
    const [formData, setFormData] = useState({
        counter: '',
        type: 'start',
        voucher_date: '',
        time: '',
        sno: '',
        denomination: '',
        number: '',
        amount: '',
    });

    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Handle input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        // Basic validation
        if (!formData.counter || !formData.voucher_date || !formData.time || !formData.sno || !formData.denomination || !formData.number || !formData.amount) {
            setError('Please fill in all fields.');
            return;
        }

        // Make API request
        fetch(`${BASE_URL}daystartclose`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    navigate('/DayStartCloseList'); // Navigate back to the list
                } else {
                    setError('Failed to add day start/close entry.');
                }
            })
            .catch((error) => {
                console.error('Error adding entry:', error);
                setError('An error occurred while adding the entry.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Day Start/Close</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-8 offset-md-2">
                        <div className="card">
                            <div className="card-header">
                                <h4>Day Start/Close Form</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3">
                                        <label htmlFor="counter">Counter</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="counter"
                                            name="counter"
                                            value={formData.counter}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="type">Type</label>
                                        <select
                                            className="form-control"
                                            id="type"
                                            name="type"
                                            value={formData.type}
                                            onChange={handleInputChange}
                                        >
                                            <option value="start">Start</option>
                                            <option value="close">Close</option>
                                        </select>
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="voucher_date">Voucher Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="voucher_date"
                                            name="voucher_date"
                                            value={formData.voucher_date}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="time">Time</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            id="time"
                                            name="time"
                                            value={formData.time}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="sno">Serial Number</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="sno"
                                            name="sno"
                                            value={formData.sno}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="denomination">Denomination</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            className="form-control"
                                            id="denomination"
                                            name="denomination"
                                            value={formData.denomination}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="number">Number</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="number"
                                            name="number"
                                            value={formData.number}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="amount">Amount</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            className="form-control"
                                            id="amount"
                                            name="amount"
                                            value={formData.amount}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="form-group text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary ms-2"
                                            onClick={() => navigate('/DayStartCloseList')}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddDayStartClose;
